export enum BooleanEnum{
    YES = 'Yes',
    NO = 'No'
}